import { SendMessageFromSurveyActionSettings } from '../../../models/SendMessageFromSurveyActionSettings';
import { ActionController } from '../../actions/ActionController';
import './SurveyContent.scss';
export const CONTENT_TYPES = [
    'builder-tabs-content.survey.types.chatbotSurvey',
    'builder-tabs-content.survey.types.solutionSurvey',
    'builder-tabs-content.survey.types.recomendationSurvey',
];
export const CONTENT_SCALES = [
    'builder-tabs-content.survey.scales.scaleStarOneToThree',
    'builder-tabs-content.survey.scales.scaleStarOneToFive',
    'builder-tabs-content.survey.scales.scaleStarOneToThreeNumber',
    'builder-tabs-content.survey.scales.scaleStarOneToFiveNumber',
];
export class SurveyContentController extends ActionController {
    static $inject = ['action', 'close', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope', '$scope', '$translate'];
    constructor(action, close, $onStateChanged, UndoRedoService, state, $rootScope, $scope, $translate) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope });
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$translate = $translate;
        this.selectedType = this.action.settings?.type;
        this.selectedScale = this.action.settings?.scale;
    }
    create() {
        return new SendMessageFromSurveyActionSettings();
    }
    async updateType() {
        this.action.settings.type = this.selectedType;
        switch (this.selectedType) {
            case 'builder-tabs-content.survey.types.chatbotSurvey':
                this.action.settings.surveyContent = await this.$translate('builder-tabs-content.survey.outuput.title.chatbotSurvey');
                break;
            case 'builder-tabs-content.survey.types.solutionSurvey':
                this.action.settings.surveyContent = await this.$translate('builder-tabs-content.survey.outuput.title.solutionSurvey');
                break;
            case 'builder-tabs-content.survey.types.recomendationSurvey':
                this.action.settings.surveyContent = await this.$translate('builder-tabs-content.survey.outuput.title.recomendationSurvey');
                break;
        }
    }
    updateScale() {
        this.action.settings.scale = this.selectedScale;
    }
}
SurveyContentController.$inject = ['action', 'close', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope', '$scope', '$translate'];
